import { ExternalProjectSecretType } from '@enums';
import { SecretParams } from '.././interfaces';

export const useMobileDevicePath = ({ projectId, secret, secretType }: SecretParams) => {
  return `${process.env.MOBILE_APP_URL}://external-redirect/${secretType}/${secret}/${projectId}`;
};